export const ALPHABETS_NUMBERS_HYPHENS =
  'Only alphabets, numbers, hyphens and space are allowed.';
export const MAX_LONG_STRING_LENGTH_WARNING = 'Max 255 characters are allowed';
export const MAX_LONG_STRING_LENGTH = 255;
// export const ALPHABETS_NUMBERS_HYPHENS_MATCHES =
//   /^[a-zA-Z0-9][a-zA-Z0-9-\s]*$/g;
export const ALPHABETS_NUMBERS_HYPHENS_MATCHES = /^[a-zA-Z0-9-\s]*$/g;
export const NUMBERS_WARNING = 'Only numbers are allowed';
export const NUMBER_STRING_MATCHES = /\d+/g;
